var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h1',[_vm._v("ASCII CAVE")]),_c('Game'),_c('br'),_c('pre',[_vm._v(_vm._s(_vm.instructions))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }